import api from './api';

// uara商品列表展示
export const getUaraTableList = params => {
  return api("post", "/v1/management/equipment-uara/list", params);
};

// 保存uara商品
export const saveUaraTableList = params => {
  return api("post", "/v1/management/equipment-uara/saveEquipment", params);
};
